// extracted by mini-css-extract-plugin
export default {"container":"TypeFilter_container__jbx5+","dropdown":"TypeFilter_dropdown__2iLQX"};